import axios from "axios";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearSettings } from "../../store/App";
import { resetSessionAuth } from "../../store/Session";
import { clearMenuOptions } from "../../store/UI";

export const useAxiosInterceptor = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const navigateRef = useRef(navigate);
  const dispatchRef = useRef(dispatch);
  const locationRef = useRef(globalThis.location.pathname);

  useEffect(() => {
    navigateRef.current = navigate;
    dispatchRef.current = dispatch;
    locationRef.current = globalThis.location.pathname;
  }, [navigate, dispatch]);

  useEffect(() => {
    const PUBLIC_ROUTES = new Set(['/', '/login']);

    const responseInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const isPublicRoute = PUBLIC_ROUTES.has(globalThis.location.pathname);

        if (error?.response?.status === 401 && !isPublicRoute) {
          dispatchRef.current(clearSettings());
          dispatchRef.current(resetSessionAuth());
          dispatchRef.current(clearMenuOptions());
          sessionStorage.clear();
          navigateRef.current('/login');
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  return null;
};